import CampoSeletor from '@/components/Formulario/CampoSeletor';
import CampoTexto from '@/components/Formulario/CampoTexto';
import Grid, { GridItem } from '@/components/layout/Grid';
import CampoMultiTexto from '@/components/Formulario/CampoMultiTexto';
import CampoMultiSeletor from '@/components/Formulario/CampoMultiSeletor';
import { Accordion } from '@/components/layout/Accordion';
import CampoNumero from '@/components/Formulario/CampoNumero';
import { NetworkIPSecDTO } from '@webip/shared/src/dto/appliance';
import Icon from '@mdi/react';
import { mdiAlertCircle } from '@mdi/js';
import HBox from '@/components/layout/HBox';
import CampoSenha from '@/components/Formulario/CampoSenha';

export const FormIPSec = ({
    value,
    onChange,
    fieldErrors,
}: {
    value: NetworkIPSecDTO;
    onChange: (v: NetworkIPSecDTO) => void;
    fieldErrors: any;
}) => {
    return (
        <Grid>
            <div style={{ position: 'absolute', height: 0 }}>
                <input
                    type="text"
                    name="username"
                    style={{ height: 0, width: 0, border: 'none', outline: 'none', margin: 0, padding: 0 }}
                />
                <input
                    type="password"
                    name="password"
                    style={{ height: 0, width: 0, border: 'none', outline: 'none', margin: 0, padding: 0 }}
                />
            </div>

            <GridItem sm={12}>
                <CampoTexto
                    value={value?.nome ?? ''}
                    onChange={v => onChange({ ...value, nome: v })}
                    label="Nome"
                    error={fieldErrors?.nome}
                />
            </GridItem>

            <GridItem sm={12}>
                <CampoMultiTexto
                    value={value?.ipsTeste}
                    onChange={v => onChange({ ...value, ipsTeste: v })}
                    label="IPs de teste"
                    error={fieldErrors?.ips_teste}
                />
            </GridItem>

            <GridItem sm={12}>
                <Accordion
                    title={
                        <HBox>
                            Fase 1
                            {fieldErrors && Object.keys(fieldErrors).some(k => k.startsWith('fase1')) && (
                                <Icon path={mdiAlertCircle} size={0.75} color="var(--tc-color-warning)" />
                            )}
                        </HBox>
                    }
                >
                    <Grid>
                        <GridItem sm={6}>
                            <CampoTexto
                                value={value?.fase1?.enderecoLocal ?? ''}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, enderecoLocal: v } })}
                                label="Endereço local"
                                error={fieldErrors?.['fase1.enderecoLocal']}
                                placeholder='Opcional'
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoMultiTexto
                                value={value?.fase1?.enderecosRemotos ?? ''}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, enderecosRemotos: v } })}
                                label="Endereços remotos"
                                error={fieldErrors?.['fase1.enderecosRemotos']}
                            />
                        </GridItem>

                        <GridItem sm={12}>
                            <CampoSeletor
                                noSearch
                                value={value?.fase1?.tipo}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, tipo: v as any } })}
                                label="Modo"
                                error={fieldErrors?.['fase1.tipo']}
                                options={[
                                    { id: 'ikev1', label: 'IKEv1' },
                                    { id: 'ikev2', label: 'IKEv2' },
                                ]}
                            />
                        </GridItem>

                        <GridItem sm={12}>
                            <CampoSeletor
                                noSearch
                                value={value?.fase1?.auth}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, auth: v as any } })}
                                label="Tipo de autenticação"
                                error={fieldErrors?.['fase1.auth']}
                                options={[
                                    { id: 'psk', label: 'Chave compartilhada' },
                                    { id: 'crt', label: 'Certificado' },
                                ]}
                            />
                        </GridItem>

                        {value?.fase1?.auth === 'psk' && (
                            <GridItem sm={12}>
                                <CampoSenha
                                    label="Chave compartilhada"
                                    value={value?.fase1?.psk ?? ''}
                                    onChange={v => onChange({ ...value, fase1: { ...value.fase1, psk: v } })}
                                    error={fieldErrors?.['fase1.psk']}
                                />
                            </GridItem>
                        )}

                        {value?.fase1?.auth === 'crt' && (
                            <GridItem sm={12}>
                                <CampoTexto
                                    label="Certificado"
                                    value={value?.fase1?.crt ?? ''}
                                    onChange={v => onChange({ ...value, fase1: { ...value.fase1, crt: v } })}
                                    error={fieldErrors?.['fase1.crt']}
                                />
                            </GridItem>
                        )}

                        <GridItem sm={6}>
                            <CampoSeletor
                                label="Hash"
                                noSearch
                                value={value?.fase1?.hash}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, hash: v as any } })}
                                error={fieldErrors?.['fase1.hash']}
                                options={[
                                    { id: 'sha1', label: 'SHA1' },
                                    { id: 'sha256', label: 'SHA256' },
                                    { id: 'sha512', label: 'SHA512' },
                                ]}
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoMultiSeletor
                                label="Criptografias"
                                noSearch
                                value={value?.fase1?.encs}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, encs: v as any[] } })}
                                error={fieldErrors?.['fase1.encs']}
                                options={[
                                    { id: 'aes128', label: 'AES 128' },
                                    { id: 'aes192', label: 'AES 192' },
                                    { id: 'aes256', label: 'AES 256' },
                                    { id: '3des', label: '3DES' },
                                ]}
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoSeletor
                                label="Grupo DH"
                                noSearch
                                value={value?.fase1?.dhGroup?.toString()}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, dhGroup: +v! } })}
                                error={fieldErrors?.['fase1.dhGroup']}
                                options={[
                                    { id: '1', label: '1 (modp768)' },
                                    { id: '2', label: '2 (modp1024)' },
                                    { id: '5', label: '5 (modp1536)' },
                                    { id: '14', label: '14 (modp2048)' },
                                    { id: '15', label: '15 (modp3072)' },
                                    { id: '16', label: '16 (modp4096)' },
                                    { id: '19', label: '19 (ecp256)' },
                                    { id: '20', label: '20 (ecp384)' },
                                    { id: '21', label: '21 (ecp521)' },
                                ]}
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoNumero
                                label="Tempo de vida (s)"
                                value={value?.fase1?.lifetime?.toString()}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, lifetime: +v } })}
                                error={fieldErrors?.['fase1.lifetime']}
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoNumero
                                label="DPD - intervalo (s)"
                                value={value?.fase1?.dpdInterval?.toString()}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, dpdInterval: +v } })}
                                error={fieldErrors?.['fase1.dpdInterval']}
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoNumero
                                label="DPD - tentativas"
                                value={value?.fase1?.dpdRetries?.toString()}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, dpdRetries: +v } })}
                                error={fieldErrors?.['fase1.dpdRetries']}
                            />
                        </GridItem>

                        <GridItem sm={(value?.fase1?.myIdType && value.fase1.myIdType !== 'auto') ? 6 : 12}>
                            <CampoSeletor
                                label="Meu identificador (myId)"
                                noSearch
                                value={value?.fase1?.myIdType ?? 'auto'}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, myIdType: v as any, myId: v === 'auto' ? undefined : value?.fase1?.myId } })}
                                error={fieldErrors?.['fase1.myIdType']}
                                options={[
                                    { id: 'auto', label: 'Auto' },
                                    { id: 'address', label: 'Endereço IP' },
                                    { id: 'fqdn', label: 'FQDN' },
                                    { id: 'key-id', label: 'Key ID' },
                                    { id: 'user-fqdn', label: 'User FQDN' },
                                ]}
                            />
                        </GridItem>

                        {(value?.fase1?.myIdType && value.fase1.myIdType !== 'auto') && (
                            <GridItem sm={6}>
                                <CampoTexto
                                    label="Meu identificador - valor"
                                    value={value?.fase1?.myId ?? ''}
                                    onChange={v => onChange({ ...value, fase1: { ...value.fase1, myId: v } })}
                                    error={fieldErrors?.['fase1.myId']}
                                />
                            </GridItem>
                        )}

                        <GridItem sm={(value?.fase1?.peerIdType && value.fase1.peerIdType !== 'auto') ? 6 : 12}>
                            <CampoSeletor
                                label="Identificador remoto (remoteId)"
                                noSearch
                                value={value?.fase1?.peerIdType ?? 'auto'}
                                onChange={v => onChange({ ...value, fase1: { ...value.fase1, peerIdType: v as any, peerId: v === 'auto' ? undefined : value?.fase1?.peerId } })}
                                error={fieldErrors?.['fase1.peerIdType']}
                                options={[
                                    { id: 'auto', label: 'Auto' },
                                    { id: 'address', label: 'Endereço IP' },
                                    { id: 'fqdn', label: 'FQDN' },
                                    { id: 'key-id', label: 'Key ID' },
                                    { id: 'user-fqdn', label: 'User FQDN' },
                                ]}
                            />
                        </GridItem>

                        {(value?.fase1?.peerIdType && value.fase1.peerIdType !== 'auto') && (
                            <GridItem sm={6}>
                                <CampoTexto
                                    label="Identificador remoto - valor"
                                    value={value?.fase1?.peerId ?? ''}
                                    onChange={v => onChange({ ...value, fase1: { ...value.fase1, peerId: v } })}
                                    error={fieldErrors?.['fase1.peerId']}
                                />
                            </GridItem>
                        )}
                    </Grid>
                </Accordion>
            </GridItem>

            <GridItem sm={12}>
                <Accordion
                    title={
                        <HBox>
                            Fase 2
                            {fieldErrors && Object.keys(fieldErrors).some(k => k.startsWith('fase2')) && (
                                <Icon path={mdiAlertCircle} size={0.75} color="var(--tc-color-warning)" />
                            )}
                        </HBox>
                    }
                >
                    <Grid>
                        <GridItem sm={12}>
                            <CampoMultiTexto
                                value={value?.fase2?.localSubnets}
                                onChange={v => onChange({ ...value, fase2: { ...value.fase2, localSubnets: v } })}
                                label="Redes locais permitidas"
                                error={fieldErrors?.['fase2.localSubnets']}
                                placeholder="Ex: 192.168.88.0/24"
                            />
                        </GridItem>

                        <GridItem sm={12}>
                            <CampoMultiTexto
                                value={value?.fase2?.remoteSubnets}
                                onChange={v => onChange({ ...value, fase2: { ...value.fase2, remoteSubnets: v } })}
                                label="Redes remotas"
                                error={fieldErrors?.['fase2.remoteSubnets']}
                                placeholder="Ex: 172.16.0.0/24"
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoSeletor
                                noSearch
                                label="Modo"
                                value={value?.fase2?.mode}
                                onChange={v => onChange({ ...value, fase2: { ...value.fase2, mode: v as any } })}
                                error={fieldErrors?.['fase2.mode']}
                                options={[
                                    { id: 'tunnel', label: 'Túnel' },
                                    { id: 'transport', label: 'Transporte' },
                                ]}
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoSeletor
                                label="Hash"
                                noSearch
                                value={value?.fase2?.hash}
                                onChange={v => onChange({ ...value, fase2: { ...value.fase2, hash: v as any } })}
                                error={fieldErrors?.['fase2.hash']}
                                options={[
                                    { id: 'sha1', label: 'SHA1' },
                                    { id: 'sha256', label: 'SHA256' },
                                    { id: 'sha512', label: 'SHA512' },
                                ]}
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoMultiSeletor
                                label="Criptografias"
                                noSearch
                                value={value?.fase2?.encs}
                                onChange={v => onChange({ ...value, fase2: { ...value.fase2, encs: v as any[] } })}
                                error={fieldErrors?.['fase2.encs']}
                                options={[
                                    { id: 'aes128', label: 'AES 128' },
                                    { id: 'aes192', label: 'AES 192' },
                                    { id: 'aes256', label: 'AES 256' },
                                    { id: '3des', label: '3DES' },
                                ]}
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoSeletor
                                label="PFS"
                                noSearch
                                value={value?.fase2?.pfs?.toString()}
                                onChange={v => onChange({ ...value, fase2: { ...value.fase2, pfs: +v! } })}
                                error={fieldErrors?.['fase2.pfs']}
                                options={[
                                    { id: '1', label: '1 (modp768)' },
                                    { id: '2', label: '2 (modp1024)' },
                                    { id: '5', label: '5 (modp1536)' },
                                    { id: '14', label: '14 (modp2048)' },
                                    { id: '15', label: '15 (modp3072)' },
                                    { id: '16', label: '16 (modp4096)' },
                                    { id: '19', label: '19 (ecp256)' },
                                    { id: '20', label: '20 (ecp384)' },
                                    { id: '21', label: '21 (ecp521)' },
                                ]}
                            />
                        </GridItem>

                        <GridItem sm={6}>
                            <CampoNumero
                                label="Tempo de vida (s)"
                                value={value?.fase2?.lifetime?.toString()}
                                onChange={v => onChange({ ...value, fase2: { ...value.fase2, lifetime: +v } })}
                                error={fieldErrors?.['fase2.lifetime']}
                            />
                        </GridItem>
                    </Grid>
                </Accordion>
            </GridItem>
        </Grid>
    );
};
